import axios from '@/utils/axios';

export default {
    namespaced: true,
    state: {
        reasons : null
    },
    mutations: {
        setReasons(state, payload) {
            state.reasons = payload;
        }
    },
    actions: {
       
        fetchReasons({commit, rootState, dispatch}) {
            return new Promise((resolve, reject) =>{
                axios.request({
                    method: "get",
                    url: `${rootState.warehouse.routePrefix}/stock-adjustment-reasons`,
                    headers: {Authorization: `Bearer ${rootState.authentication.token}`}
                })
                .then(response => {
                    commit('setReasons', response.data);
                    resolve(response)
                })
                .catch(error => {
                    if(error.response && error.response.status == 401) dispatch('authentication/logout',{ message: 'Session Expired! Please Login.' }, {root: true});
                    reject(error)
                });
            })
        }

    }
}